import styled from "styled-components";
import { Box } from "@mui/material";

export const StoryWrapper = styled(Box)`
	width: 90%;

	margin-top: 40px;
	.delete_icon {
		position: absolute;
		right: 0;
		top: -40px;
	}
	.MuiInputBase-multiline {
		padding: 0;
	}
	.MuiInputBase-inputMultiline {
		padding: 12px;
	}
`;
